import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FileManagerMode, RoutesEnum} from '../../../global';
import { NgIf, NgFor } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

export type BreadcrumbSection = {
    id: number | string;
    name: string;
}

@Component({
    selector: 'slm-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    imports: [NgIf, NgFor, RouterLink, TranslatePipe]
})
export class BreadcrumbComponent {
  @Input() sections: Array<BreadcrumbSection>;
  @Input() baseUrl:  RoutesEnum;
  @Input() mode: FileManagerMode = 'page';

  @Output() breadcrumbClicked = new EventEmitter<string>();

  public trackById = (_, item: BreadcrumbSection) => item.id;
}
